import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-d564bda8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_2 = { class: "flex relative w-1/3 h-auto" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-8" }
const _hoisted_4 = { class: "flex flex-row justify-between mb-8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-lg" }, " Add new collaborator ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "w-full mb-4" }
const _hoisted_10 = {
  key: 0,
  class: ""
}
const _hoisted_11 = { class: "w-full mb-4" }
const _hoisted_12 = { class: "w-full mb-4" }
const _hoisted_13 = { class: "w-full mb-4" }
const _hoisted_14 = { class: "w-full mb-4" }
const _hoisted_15 = { class: "flex flex-row justify-between items-center" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "relative flex flex-row items-center justify-center ml-4 mr-4" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 2,
  class: "ml-4"
}
const _hoisted_20 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, _hoisted_7)
              ]),
              _createElementVNode("form", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_DropDown, {
                    modelValue: _ctx.internal,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.internal) = $event)),
                    label: "Select a collaborator",
                    options: _ctx.internals,
                    typeInput: "text",
                    disabled: _ctx.loading,
                    name: "internal",
                    isError: _ctx.fieldErrors.internal
                  }, null, 8, ["modelValue", "options", "disabled", "isError"])
                ]),
                (_ctx.newCollaborator)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_TextField, {
                          name: "first_name",
                          label: "First name",
                          typeInput: "text",
                          disabled: _ctx.loading,
                          modelValue: _ctx.first_name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.first_name) = $event)),
                          isError: _ctx.fieldErrors.first_name
                        }, null, 8, ["disabled", "modelValue", "isError"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_TextField, {
                          name: "last_name",
                          label: "Last name",
                          typeInput: "text",
                          disabled: _ctx.loading,
                          modelValue: _ctx.last_name,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.last_name) = $event)),
                          isError: _ctx.fieldErrors.last_name
                        }, null, 8, ["disabled", "modelValue", "isError"])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_TextField, {
                          name: "email",
                          label: "Email",
                          typeInput: "email",
                          disabled: _ctx.loading,
                          modelValue: _ctx.email,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event)),
                          isError: _ctx.fieldErrors.email
                        }, null, 8, ["disabled", "modelValue", "isError"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_DropDown, {
                          modelValue: _ctx.role,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.role) = $event)),
                          label: "Select a role",
                          options: _ctx.collaborator_role,
                          typeInput: "text",
                          disabled: _ctx.loading,
                          name: "role",
                          isError: _ctx.fieldErrors.role
                        }, null, 8, ["modelValue", "options", "disabled", "isError"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  class: "btn-outline-lg"
                }, "Cancel"),
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                  disabled: !_ctx.meta.valid,
                  class: _normalizeClass(["disabled:opacity-50 disabled:cursor-not-allowed", {
                'btn-filled-lg': !_ctx.loading,
                'btn-filled-lg-loading': _ctx.loading,
              }])
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    (_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_Spinner, {
                          key: 0,
                          color: "white",
                          height: "6",
                          width: "6",
                          border: "2"
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Add "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_19, "Loading..."))
                  ])
                ], 10, _hoisted_16)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20))
      : _createCommentVNode("", true)
  ]))
}